export const TRIAL_EXPIRED_AB_TEST_URL = '/v1/ab-test/trial-expired';

export const TrialExpiredAbTestEndpoints = {
  setTrialExpiredVariant: 'setTrialExpiredVariant',
} as const;
